import { render } from "./StandardPartsCatalog.vue?vue&type=template&id=2cd30a77"
import script from "./StandardPartsCatalog.vue?vue&type=script&lang=js"
export * from "./StandardPartsCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__